<app-card-widget title="Client Invoices" [subtitle]="subtitle" *ngIf="data$ | async as data">

  <div class="item-container">
    <div class="item">
      <div class="label">Open</div>
      <div class="primary">{{data.open.amount | money }}</div>
      <div class="secondary">{{data.open.count}} invoice(s)</div>
    </div>
    <div class="item">
      <div class="label">Overdue</div>
      <div class="primary">{{data.overdue.amount | money }}</div>
      <div class="secondary">{{data.overdue.count}} invoice(s)</div>
    </div>
    <div class="item">
      <div class="label">Paid</div>
      <div class="primary">{{data.paid.amount | money }}</div>
      <div class="secondary">{{data.paid.count}} invoice(s)</div>
    </div>
  </div>

  <mat-nav-list *ngIf="showInvoices">
    <mat-list-item *ngFor="let invoice of data.invoices" (click)="showInvoice(invoice.id)">
      <mat-icon matListIcon>receipt</mat-icon>
      <h3 matLine>
        <span class="line-item">{{ invoice.number }}</span>
        <span class="line-item">{{ getPaymentStatus(invoice) | label }}</span>
        <span class="line-item">{{ getTotalOpen(invoice) | money }}</span>
        <span class="line-item">{{ invoice.due_date | date:'shortDate' }}</span>
      </h3>
    </mat-list-item>
  </mat-nav-list>

  <mat-card-actions align="end">
    <button type="button" mat-button (click)="toggleInvoices()">{{ showInvoices ? "Hide Details" : "Show Details" }}</button>
  </mat-card-actions>

</app-card-widget>
